import "../App.css"


export const Cell = ({lesson, onSelect, disabled}) => {
    const time = lesson?.dateBeg?.split(' ')[1].split(':')[0] + ':' + lesson?.dateBeg?.split(' ')[1].split(':')[1]

    return(
        <>
        <button className={`timeCell`} disabled={!lesson.isActive || disabled} onClick={() => {
            onSelect(lesson)
        }}>
            <span style={!lesson.isActive ? { textDecoration: 'line-through' } : {}}>
                {time}
            </span>
        </button>
        </>
    )
}